/*
 * サブシステム名：
 * 機能名：受注・実績登録
 * 表示項目カスタマイズ(石橋梱包運輸)
 */

import D2PRMD0020 from '@/views/PRM/D2PRMD0020.js'
import message from '@/ddv2.library/messages'

export default ({
  extends: D2PRMD0020,
  name: 'HaisoMeisaiEditCustomForIshibashi',
  methods: {
    // 初期値設定
    custoMizeHaisoMeisaiInit: function () {
      this.$refs.seikyuYoteiYmd.onCalendarInput(this.viewsData.vwUnkoJisseki.unkoYmd)
      this.recHaisoMeisai.unchinKeisanKbn = '03'
      if (this.viewsData.vwUnkoJisseki.haishaKbn !== '03') {
        this.recHaisoMeisai.seikyuShashuSbt = this.jishaSharyoSbt ? this.jishaSharyoSbt : this.recHaisoMeisai.seikyuShashuSbt
      } else {
        this.recHaisoMeisai.seikyuShashuSbt = this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt ? this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt : this.recHaisoMeisai.seikyuShashuSbt
      }
    },
    custoMizeHaisoMeisaiValidate: function () {
      if (!this.recHaisoMeisai.seikyuShashuSbt) {
        this.$refs.seikyuShashuSbt[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      return true
    },
    custoMizeChangeCarInfo: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn !== '03') {
        this.recHaisoMeisai.seikyuShashuSbt = this.jishaSharyoSbt ? this.jishaSharyoSbt : this.recHaisoMeisai.seikyuShashuSbt
      } else {
        this.recHaisoMeisai.seikyuShashuSbt = this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt ? this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt : this.recHaisoMeisai.seikyuShashuSbt
      }
    },
    custoMizeYoshaUnchin: function (calcUnchin) {
      if (this.viewsData.vwUnkoJisseki.haishaKbn !== '03') { return }
      let tanka = this.recHaisoMeisai.tanka

      if (tanka === undefined || tanka === '' || tanka === null) { tanka = '0' }
      const yoshaUnchin = this.calcFraction(parseFloat(tanka, 10) * 0.9)
      this.$set(this.recHaisoMeisai, 'yoshaKihonUnchin', yoshaUnchin)
    },
    custoMizeInitBindVariables: function () {
      const handOverUnkoYmd = this.viewsData.vwUnkoJisseki.unkoYmd
      const handOverSeikyuYoteiYmd = this.recHaisoMeisai.seikyuYoteiYmd

      this.initBindVariables()
      this.recHaisoMeisai.unchinKeisanKbn = '03'
      this.$refs.unkoYmd.onCalendarInput(handOverUnkoYmd)
      this.$refs.seikyuYoteiYmd.onCalendarInput(handOverSeikyuYoteiYmd)
    },
    custoMizeGetSavedInputMethod: function () {
      return {
        unkoYmd: this.viewsData.vwUnkoJisseki.unkoYmd,
        seikyuYoteiYmd: this.recHaisoMeisai.seikyuYoteiYmd
      }
    },
    custoMizeSavedInputRestore: function (c) {
      this.$refs.unkoYmd.onCalendarInput(c.unkoYmd)
      this.$refs.seikyuYoteiYmd.onCalendarInput(c.seikyuYoteiYmd)
    },
    custoMizeSetHachhakuchiTanka: function () {
      this.custoMizeYoshaUnchin()
    }
  }
})
